// tslint:disable
export enum States {
    /**
     * @description UNKNOWN
     */
    UNKNOWN = 0,
    /**
     * @description ALABAMA
     */
    ALABAMA = 1,
    /**
     * @description ALASKA
     */
    ALASKA = 2,
    /**
     * @description AMERICAN SAMOA
     */
    AMERICANSAMOA = 3,
    /**
     * @description ARIZONA
     */
    ARIZONA = 4,
    /**
     * @description ARKANSAS
     */
    ARKANSAS = 5,
    /**
     * @description CALIFORNIA
     */
    CALIFORNIA = 6,
    /**
     * @description COLORADO
     */
    COLORADO = 7,
    /**
     * @description CONNECTICUT
     */
    CONNECTICUT = 8,
    /**
     * @description DELAWARE
     */
    DELAWARE = 9,
    /**
     * @description DISTRICT OF COLUMBIA
     */
    DISTRICTOFCOLUMBIA = 10,
    /**
     * @description FEDERATED STATES OF MICRONESIA
     */
    FEDERATEDSTATESOFMICRONESIA = 11,
    /**
     * @description FLORIDA
     */
    FLORIDA = 12,
    /**
     * @description GEORGIA
     */
    GEORGIA = 13,
    /**
     * @description GUAM
     */
    GUAM = 14,
    /**
     * @description HAWAII
     */
    HAWAII = 15,
    /**
     * @description IDAHO
     */
    IDAHO = 16,
    /**
     * @description ILLINOIS
     */
    ILLINOIS = 17,
    /**
     * @description INDIANA
     */
    INDIANA = 18,
    /**
     * @description IOWA
     */
    IOWA = 19,
    /**
     * @description KANSAS
     */
    KANSAS = 20,
    /**
     * @description KENTUCKY
     */
    KENTUCKY = 21,
    /**
     * @description LOUISIANA
     */
    LOUISIANA = 22,
    /**
     * @description MAINE
     */
    MAINE = 23,
    /**
     * @description MARSHALL ISLANDS
     */
    MARSHALLISLANDS = 24,
    /**
     * @description MARYLAND
     */
    MARYLAND = 25,
    /**
     * @description MASSACHUSETTS
     */
    MASSACHUSETTS = 26,
    /**
     * @description MICHIGAN
     */
    MICHIGAN = 27,
    /**
     * @description MINNESOTA
     */
    MINNESOTA = 28,
    /**
     * @description MISSISSIPPI
     */
    MISSISSIPPI = 29,
    /**
     * @description MISSOURI
     */
    MISSOURI = 30,
    /**
     * @description MONTANA
     */
    MONTANA = 31,
    /**
     * @description NEBRASKA
     */
    NEBRASKA = 32,
    /**
     * @description NEVADA
     */
    NEVADA = 33,
    /**
     * @description NEW HAMPSHIRE
     */
    NEWHAMPSHIRE = 34,
    /**
     * @description NEW JERSEY
     */
    NEWJERSEY = 35,
    /**
     * @description NEW MEXICO
     */
    NEWMEXICO = 36,
    /**
     * @description NEW YORK
     */
    NEWYORK = 37,
    /**
     * @description NORTH CAROLINA
     */
    NORTHCAROLINA = 38,
    /**
     * @description NORTH DAKOTA
     */
    NORTHDAKOTA = 39,
    /**
     * @description NORTHERN MARIANA ISLANDS
     */
    NORTHERNMARIANAISLANDS = 40,
    /**
     * @description OHIO
     */
    OHIO = 41,
    /**
     * @description OKLAHOMA
     */
    OKLAHOMA = 42,
    /**
     * @description OREGON
     */
    OREGON = 43,
    /**
     * @description PALAU
     */
    PALAU = 44,
    /**
     * @description PENNSYLVANIA
     */
    PENNSYLVANIA = 45,
    /**
     * @description PUERTO RICO
     */
    PUERTORICO = 46,
    /**
     * @description RHODE ISLAND
     */
    RHODEISLAND = 47,
    /**
     * @description SOUTH CAROLINA
     */
    SOUTHCAROLINA = 48,
    /**
     * @description SOUTH DAKOTA
     */
    SOUTHDAKOTA = 49,
    /**
     * @description TENNESSEE
     */
    TENNESSEE = 50,
    /**
     * @description TEXAS
     */
    TEXAS = 51,
    /**
     * @description UTAH
     */
    UTAH = 52,
    /**
     * @description VERMONT
     */
    VERMONT = 53,
    /**
     * @description VIRGIN ISLANDS
     */
    VIRGINISLANDS = 54,
    /**
     * @description VIRGINIA
     */
    VIRGINIA = 55,
    /**
     * @description WASHINGTON
     */
    WASHINGTON = 56,
    /**
     * @description WEST VIRGINIA
     */
    WESTVIRGINIA = 57,
    /**
     * @description WISCONSIN
     */
    WISCONSIN = 58,
    /**
     * @description WYOMING
     */
    WYOMING = 59,
    /**
     * @description ARMED FORCES AMERICAS
     */
    ARMEDFORCESAMERICAS = 60,
    /**
     * @description ARMED FORCES EUROPE
     */
    ARMEDFORCESEUROPE = 61,
    /**
     * @description ARMED FORCES PACIFIC
     */
    ARMEDFORCESPACIFIC = 62,
}
